import { render, staticRenderFns } from "./OrderAppoint.vue?vue&type=template&id=a44b7310"
import script from "./OrderAppoint.vue?vue&type=script&lang=js"
export * from "./OrderAppoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports